import React from 'react';
import PropTypes from 'prop-types';
import externalUrl from '@Utils/ExternalUrl';
import { elsevierExternalUrlStrings } from '@Components/Results/constants';
import { LinkElement } from '@els/els-react--link-element';

function CitationsCustomLinkComponent({ citation, fullTextTrackingData, onClick }) {
  if (!citation.fullTextUrl) {
    return null;
  }

  let externalUrlVal = externalUrl(citation.fullTextUrl);
  if (
    window.s &&
    window.s.visitor &&
    externalUrlVal &&
    elsevierExternalUrlStrings.some((substring) => externalUrlVal.includes(substring))
  ) {
    externalUrlVal = window.s.visitor.appendVisitorIDsTo(externalUrlVal);
  }
  return (
    <LinkElement
      isExternal
      navigation
      data-e2e="e2e-full-text-button"
      href={externalUrlVal}
      onClick={() => onClick(citation)}
      className="e2e-full-text u-els-font-size-base"
      {...fullTextTrackingData}>
      Full Text
    </LinkElement>
  );
}

CitationsCustomLinkComponent.propTypes = {
  citation: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  // for analytics
  fullTextTrackingData: PropTypes.object.isRequired,
};

export default CitationsCustomLinkComponent;
